module.exports = __webpack_public_path__ + "media/images/vip-events-47842079fc36deb2ab0258d25e5ce397.svg";